<template>
  <div class="PC_home">
      <div class="header_log">
          <div class="logBox">
              <img style="width:100%" src="@assets/img/h5_login.png" alt="">
          </div>
          <div class="desc">
              <p>{{$t('other.a406')}}</p>
              <p>{{$t('other.a1744')}}</p>
          </div>
      </div>
      <div class="header_right">
          <!-- <el-input v-model="searchText" placeholder="产品查找"><i class="iconfont "></i></el-input>
          <el-button type="primary">{{$t('other.a245')}}</el-button> -->
      </div>
  </div>
</template>

<script>
export default {
data(){
return{
    searchText:null,
}
},
created(){

},
methods:{

}
}

</script>
<style lang="scss" scoped>
.PC_home{
    background-color: #fff;
    box-sizing: border-box;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;

    .header_right{
        flex: 1;
        display: flex;
    }

    .header_log{
        display: flex;
        align-items: center;


        .desc{
            margin: 0  10px;
        }
    }

    .logBox{
        width: 60px;
        height: 60px;
        overflow: hidden;
    }
}
</style>